// extracted by mini-css-extract-plugin
export default {"wrapper":"CymbioSpinner_wrapper__t46Ao","centerVertically":"CymbioSpinner_centerVertically__qFkO8"};